import {
  DL_KYC_BASE_URL,
  DL_KYC_CLIENT_ID,
  DL_KYC_CLIENT_SECRET,
  DL_KYC_REDIRECT_URL,
  DL_KYC_STATUS_FAILED,
  DL_KYC_STATUS_SUCCESS,
  DOCUMENT_UPLOAD_BUCKET,
  LOHOLD_BASE_URL,
  LOHOLD_CLIENT_ID,
  LOHOLD_CLIENT_SECRET,
  LOHOLD_REDIRECT_URL,
  LOHOLD_STATUS_FAILED,
  LOHOLD_STATUS_SUCCESS,
  REPAY_RAZORPAY_KEY,
  GPS_BUCKET_NAME,
  GPS_BUCKET_FOLDER,
} from './env-constants-resolvers';

export * from './request-related';
export * from './get-loading-one-liners';
export * from './env-specific-constants';

export const NON_LAYOUT_ROUTES = [
  '/',
  '/SignUp',
  '/fair-practices',
  '/lending-partners',
  '/privacy-policy',
  '/terms-and-conditions',
];
export const COMMON_CONTAINER_MFE = ['AUTH', 'AP', 'DRP', 'KYC', 'MARKETING'];
export const SESSION_EXPIRED_MODAL_EXCLUDED_ROUTES = [
  '/dynamic-tile',
  '/SignUp',
  '/fibe-experience',
];
export const NON_PROGRESS_CONTAINER = [
  'MARKETING',
  '/disbursement',
  '/learn',
  '/blogs',
  '/tutorial',
  '/tutorial-player',
  '/instant-cash',
];

export const APPLICATION_PROCESS_ROUTES = [
  '/application-process',
  '/pre-pan',
  '/post-pan',
  '/bank-statement',
  '/kyc-process',
  '/itr-journey',
  '/auto-debit',
  '/suspend-landing',
  '/suspend',
  '/first-jobber-landing',
  '/first-jobber',
  '/lo-hold',
];

export const HORIZONTAL_PROGRESS_BAR_ROUTES = [
  '/application-process',
  '/pre-pan',
  '/post-pan',
  '/bank-statement',
  '/suspend',
  '/missing-salary',
  '/offer-letter',
  '/salary-slip',
  '/suspend-landing',
  '/technical-issue',
  '/first-jobber-landing',
  '/first-jobber',
  '/technical-issue-fj',
  '/kyc-process',
  '/itr-journey',
  '/auto-debit',
  '/upgrade-your-limit',
  '/upload-bs',
  '/lo-hold',
  '/upload-kyc-doc',
  '/upload-address',
  '/upload-address-doc',
  '/upload-bank-details',
  '/upload-selfie',
  '/upload-passbook',
  '/upload-pan',
  '/upload-cancelled-cheque',
  '/upload-bank-statement',
  '/under-review',
  '/digilocker-error',
  '/error-page',
  '/consent-letter',
  '/nach-cancellation/submitted-request',
];

export const APPLICATION_PROCESS_ACTION_TYPES = [
  'COMPLETE_PROFILE',
  'COMPLETE_BANK_STATEMENT',
  'COMPLETE_YOUR_KYC',
  'COMPLETE_ITR',
  'SETUP_AUTO_DEBIT',
];

export const ONLY_SIDEBAR_HEADER = ['/dashboard'];
export const EXTENDED_LAYOUT_HEIGHT = [
  '/loan-statement',
  '/disbursement',
  '/loan-details',
];
export const SCREEN_HEIGHT_PAGES = [
  '/suspend',
  '/suspend-landing',
  '/offer-letter',
  '/salary-slip',
  '/missing-salary',
  '/technical-issue',
  '/technical-issue-fj',
  '/about-us',
  '/fibo',
  '/notification',
  '/chatbot',
  '/contact-us',
  '/faq',
  '/learn',
  '/upgrade-your-limit',
  '/drp-settlement',
  '/offers',
  '/first-jobber',
  '/first-jobber-landing',
  '/tutorial-player',
];

export const POLICY_TNC_URL =
  'https://portal-ec2.fibe.in/privacy-policy?src=mobile';
export const CREDIT_SCORE_TNC_WEB_URL = 'https://dms.fibe.in/freecredit-terms';
export const TERMS_AND_CONDITIONS_URL =
  'https://portal-ec2.fibe.in/terms-and-conditions?src=mobile';
export const VIDEO_KYC_TNC = 'https://www.fibe.in/vkyc-tnc/?src=mobile';

export const WEB_OTP_TEMPLATE = 'OTP_LOGIN_WEB';
export const CASH_DISB_OTP_TEMPLATE = 'OTP_Cash_DISB';
export const FIRST_JOBBER_OTP_TEMPLATE = 'OTP_FIRST_JOBBER';
export const OTP_CHECKOUT_DISB = 'OTP_CHECKOUT_DISB';

export const OTP_FOR_CURR_ADD_CHANGE = 'OTP_CURR_ADD_CHANGE';
export const OTP_FOR_EMAIL_CHANGE = 'OTP_EMAIL_CHANGE';
export const OTP_FOR_MOB_CHANGE = 'OTP_MOB_CHANGE';
export const OTP_FOR_OFFICE_ADD_CHANGE = 'OTP_OFFICE_ADD_CHANGE';
export const OTP_FOR_BANK_DET_CHANGE = 'OTP_BANK_DET_CHANGE';

// export const OCR_ENDPOINT = 'https://ind-docs.hyperverge.co/v2.0/readKYC';
export const OCR_ENDPOINT = 'https://portal-qa.fibe.in/v2.0/readKYC';
export const LIVENESS_ENDPOINT = 'https://portal-qa.fibe.in/v1/photo/liveness';
export const DRIVING_LICENSE_API = 'https://portal-qa.fibe.in/v2.0/readDL';
// export const DRIVING_LICENSE_API = 'https://ind-docs.hyperverge.co/v2.0/readDL'

// DOCS: Login Page Screen Constants
export const SEND_OTP_SCREEN = 'SEND_OTP_SCREEN';
export const VERIFY_OTP_SCREEN = 'VERIFY_OTP_SCREEN';
export const SOCIAL_LOGIN_SCREEN = 'SOCIAL_LOGIN_SCREEN';

//const url = 'http://localhost:8080/'  // local server
const url = 'https://portal-qa.fibe.in/';

/* Digilocker Credentials */
export const DIGILOCKER_KYC = {
  CLIENT_ID: DL_KYC_CLIENT_ID,
  CLIENT_SECRET: DL_KYC_CLIENT_SECRET,
  REDIRECT_URL: DL_KYC_REDIRECT_URL,
  BASE_URL: DL_KYC_BASE_URL,
  STATUS_FAILED: DL_KYC_STATUS_FAILED,
  STATUS_SUCCESS: DL_KYC_STATUS_SUCCESS,
};

export const DIGILOCKER_LO_HOLD = {
  CLIENT_ID: LOHOLD_CLIENT_ID,
  CLIENT_SECRET: LOHOLD_CLIENT_SECRET,
  REDIRECT_URL: LOHOLD_REDIRECT_URL,
  BASE_URL: LOHOLD_BASE_URL,
  STATUS_FAILED: LOHOLD_STATUS_FAILED,
  STATUS_SUCCESS: LOHOLD_STATUS_SUCCESS,
};

export const KYCFIELED = {
  SELFIE_ID: '9',
  BANK_STATEMENT_ID: '1',
  SALARY_SLIP_ID: '11',
  CANCEL_CHEQUE_ID: '10',
  OFFER_LETTER_ID: '34',
  AADHAR_ID: '4',
  PANCARD_ID: '8',
  DRIVING_LICENCE_ID: '3',
  PASSPORT_ID: '2',
  VOTER_ID: '5',
  DISPUTE_ID: '61',
  NACH_ID: '74',
  OFFLINE_KYC_ID: '83',
  PASSBOOK_ID: '85',
  ELECTRICITY_BILL_ID: '7',
  POSTPAID_BILL_ID: '6',
  GAS_BILL_ID: '43',
  RENT_AGREEMENT_ID: '13',
  SALES_DEED_OWN_HOUSE_PROOF_ID: '120',
  BROAD_BAND_BILL_ID: '121',
  WATER_BILL_ID: '122',
  PROPERTY_TAX_BILL_ID: '109',
  CONSENT_LETTER_ID: '137',
};

export const LOCATION_MANDATE = {
  REQUIRED: 'REQUIRED',
  NOTREQUIRED: 'NOTREQUIRED',
  OPTIONAL: 'OPTIONAL',
};

export const BUCKET = DOCUMENT_UPLOAD_BUCKET;
export const repayRazorpayKey = REPAY_RAZORPAY_KEY;

export const MAXBUPA_ASSIGNMENT_URL = `assignment-letter-max-bupa`;

export const HDFC_ASSIGNMENT_URL = `assignment-letter-hdfc-ergo`;

export const ES_SANCTION_LETTER = `sanction-letter-aspl`;

export const ES_CLICKANDWRAP_AGREEMENT = `click-wrap-aspl`;

export const KEY_FACTS_STATEMENT = `key-facts-statement`;

export const ES_CLICKANDWRAP_HOSPITECH = `click-wrap-checkout-hospitech`;

export const DOWNPAYMENT_CHECKPAYMENTSTATUS_COUNTER = 60;
export const DOWNPAYMENT_REDIRECT_COUNTER = 5;

export const MAXBUPA_MERCHANT_ID = 3375;
export const MAXBUPA_MERCHANT_ID_QA = 1142;

export const HDFC_MERCHANT_ID = 3598;
export const HDFC_MERCHANT_ID_QA = 1197;

export const quessUtmSourcesSet = new Set([
  'QUESS_CORP',
  'QUESS_SHAKTI',
  'QUESS_DASH',
]);
export const APP_STORE_URL_IOS =
  'https://apps.apple.com/in/app/fibe-formerly-earlysalary/id1094602630';
export const PLAY_STORE_URL_AND =
  'https://play.google.com/store/apps/details?id=com.earlysalary.android&hl=en_IN&gl=IN';

export const GPS_BUCKET = GPS_BUCKET_NAME;

export const GPS_BUCKET_FOLDER_NAME = GPS_BUCKET_FOLDER;
